// src/frontend/App.jsx
import React, {useEffect, useState} from 'react';
import {RoomProvider, useRoom} from './context/RoomContext';
import {NotificationProvider} from './context/NotificationContext'; // ← Neu
import Home from './pages/Home';
import Room from './pages/Room';
import NavBar from './components/layout/NavBar';
import {Toaster} from "react-hot-toast";

function AppContent({theme, toggleTheme}) {
    const {roomId} = useRoom();
    return roomId ? <Room theme={theme} toggleTheme={toggleTheme}/> : <Home theme={theme} toggleTheme={toggleTheme}/>;
}

export default function App() {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        const saved = localStorage.getItem('theme');
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const initial = saved || (prefersDark ? 'dark' : 'light');
        setTheme(initial);
        document.documentElement.classList.add(initial);
    }, []);

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        document.documentElement.classList.replace(theme, newTheme);
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
    };

    return (
        <NotificationProvider> // ← Neu: Wickelt alles
            <RoomProvider>
                <div className="min-h-screen">
                    <NavBar theme={theme} toggleTheme={toggleTheme}/>
                    <div className="pt-16">
                        <AppContent theme={theme} toggleTheme={toggleTheme}/>
                    </div>
                    {/* Globaler Toaster – immer da */}
                    <Toaster
                        position="top-right"
                        toastOptions={{
                            duration: 4000,
                            style: {
                                borderRadius: '10px',
                                background: theme === 'dark' ? '#1f2937' : '#ffffff',
                                color: theme === 'dark' ? '#ffffff' : '#1f2937',
                                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.2)',
                                border: theme === 'dark' ? '1px solid #374151' : '1px solid #e5e7eb',
                            },
                            success: {
                                iconTheme: {
                                    primary: '#10b981',
                                    secondary: '#ffffff',
                                },
                            },
                            error: {
                                iconTheme: {
                                    primary: '#ef4444',
                                    secondary: '#ffffff',
                                },
                            },
                        }}
                    />
                </div>
            </RoomProvider>
        </NotificationProvider>
    );
}